import {css, view, tokens, createViewConfig} from '@sail/ui';
import {useTheme} from '../../ThemeProvider';
import type {Theme} from '../../theme';

type MessageType = 'user' | 'bot' | 'agent' | 'event';

const getBgColors = (theme: Theme): Record<MessageType, string> => ({
  user: theme.messageBubbleBackground,
  bot: 'transparent',
  agent: tokens.color.neutral[0].toString(),
  event: 'transparent',
});

const getTextColors = (theme: Theme): Record<MessageType, string> => ({
  user: theme.messageBubbleText,
  bot: 'text',
  agent: 'text',
  event: 'subdued',
});

const getAdditionalStyle = (messageType: MessageType) => {
  switch (messageType) {
    case 'agent':
      return {
        paddingX: 'space.150',
        paddingY: 'small',
        borderRadius: 20,
        borderStyle: 'solid',
        borderWidth: 'small',
        borderColor: 'border',
      };
    case 'user':
      return {
        paddingX: 'space.150',
        paddingY: 'small',
        borderRadius: 20,
      };
    default:
      return {};
  }
};

export type ChatBubbleNextProps = {
  children?: React.ReactNode;
  messageType: MessageType;
};

export const ChatBubbleNextConfig = createViewConfig({
  props: {} as ChatBubbleNextProps,
  name: 'ChatBubble',
});

export const ChatBubbleNext = ChatBubbleNextConfig.createView(
  ({children, messageType, ...props}) => {
    const theme = useTheme();
    const bgColors = getBgColors(theme);
    const textColors = getTextColors(theme);

    return (
      <view.div
        {...props}
        data-testid="chat-bubble"
        className="uh-conversations-chat-bubble"
        uses={[
          css({
            backgroundColor: bgColors[messageType],
            color: textColors[messageType],
            transition: 'border-radius .2s',
          }),
          css(getAdditionalStyle(messageType)),
        ]}
      >
        {children}
      </view.div>
    );
  },
);
